import * as React from "react";
import styled from "styled-components";
import { Img, WmkImage } from "wmk-image";
import { IconCopyFields } from "../../../fragments/iconCopyFields";
import { BlockLogoDisplayFields } from "../../../fragments/blockLogoDisplayFields";
import { Col, Container, Row } from "react-bootstrap";
import { colors } from "../../../vars/colors";

const Wrap = styled(Container)`
  // margin: 0.5rem 2rem;
  width: 100vw;
  margin-left: var(--bs-gutter-x,-0.75rem);
  margin-right: var(--bs-gutter-x,-0.75rem);
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  
  .header-section {
    padding 1.5rem;
    background: #EA682E;
    width: 100%;
  }
  .logo-row {
    width: 100%;
    padding: 2rem 0;
    justify-content: center;
  }
  .logo-col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  p {
    color: white !important;
    text-align: center;
    line-height: 1.5rem;
    font-family: "Nunito Sans";
    font-size: 18px;
  }
  h2 {
    text-align: center;
    font-size: 35px;
    margin-bottom: 1rem;
    color: white;
    font-weight: 700;
  }
`;
const ImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  // padding: 2rem 20%;
`;

const BlockLogoDisplay = ({ block }: { block: BlockLogoDisplayFields }) => {
  return (
    <Wrap fluid>
      <Row className="header-section">
        <Col>
          <h2>{block.header}</h2>
          <p>{block.subheader.toUpperCase()}</p>
        </Col>
      </Row>
      <Row className="logo-row">
        {block?.logos.length &&
          block.logos.map((logo) => {
            const logoImage = new Img(logo);
            return (
              <Col lg={block?.logos.length <= 4 ? 3 : 2} md={6} sm={6} xs={12} className="logo-col">
                <ImageWrap>
                  <WmkImage image={logoImage} />
                </ImageWrap>
              </Col>
            );
          })}
      </Row>
    </Wrap>
  );
};

export default BlockLogoDisplay;
